// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"f76612f8","113":"f54d3edf","142":"6ec53d73","260":"cd7036d0","352":"dd0c73d7","438":"d605f8fd","538":"6f3e3f35","648":"b9f9a474"}[chunkId] + ".chunk.js";
};